import { useEffect, useState } from 'react'
import useAuctionRoute from './useAuctionRoute'
import getAuctionItems from '../axios/getAuctionItems'
import getPagination from '@utilities/functions/getPagination'
import useDidMountEffect from '@utilities/hooks/useDidMountEffect'

const PER_PAGE = 24

const convertPagination = ({ initTotalAuctions, initPage }: any) => {
  const { current_page, per_page, total, total_pages } = getPagination(
    initTotalAuctions,
    initPage
  )
  return {
    currentPage: current_page,
    totalPages: total_pages,
    itemsPerPage: per_page,
    totalItems: total,
  }
}

const useFilterAuctions = ({
  initAuctions,
  initTotalAuctions,
  initPage,
}: any = {}) => {
  const {
    route: { base, category, page, changePage, changeCategory },
    query: {
      queries: { location, searchInput, pickupDate, condition },
    },
  } = useAuctionRoute()

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setAuctions(initAuctions)
  }, [initAuctions])

  const [auctions, setAuctions] = useState<any>(initAuctions)
  const [pagination, setPagination] = useState<any>(
    convertPagination({ initTotalAuctions, initPage })
  )

  const updateAuctions = async () => {
    setIsLoading(true)
    const { auctionRequest, auctionCount } = await getAuctionItems({
      base,
      category,
      page,
      location,
      searchInput,
      pickupDate,
      condition,
    })
    setAuctions(auctionRequest)
    setPagination((prev: any) => ({
      ...prev,
      totalPages: Math.ceil(auctionCount / PER_PAGE),
      totalItems: auctionCount,
    }))
    setIsLoading(false)
  }

  useDidMountEffect(() => {
    updateAuctions()
  }, [base, category, page, location, searchInput, pickupDate, condition])

  const updatePage = (pgVal: number) => {
    setPagination((prevState: any) => ({ ...prevState, currentPage: pgVal }))
    changePage(pgVal)
  }

  const updateCategory = (val: string) => {
    changeCategory(val)
  }

  const handler: any = {
    changePage: updatePage,
    changeCategory: updateCategory,
  }

  return {
    auctions,
    setAuctions,
    pagination,
    setPagination,
    handler,
    isLoading,
  }
}

export default useFilterAuctions
